// Ekranların kullandığı react-native export'ları + Text/TextInput override'ı
// (AppText'ten, Inter fontlu). `export * from 'react-native'` RN'in tembel
// getter'larını tetikleyip "native module doesn't exist" hatası verdiği için
// kullanılan isimleri açıkça listeliyoruz.
export {
  AccessibilityInfo,
  ActivityIndicator,
  ActionSheetIOS,
  Animated,
  BackHandler,
  Dimensions,
  FlatList,
  I18nManager,
  Image,
  KeyboardAvoidingView,
  Linking,
  PanResponder,
  Platform,
  ScrollView,
  Switch,
  Share,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';

export { Text, TextInput } from './AppText';
// The system alert on iOS and Android; an in-app dialog on the web, where
// React Native Web's Alert does nothing (alert.ts).
export { Alert } from './alert';
export { default as Modal } from './ScreenModal';
